import { httpClient } from './http-client.service';
import type { CreateDownloadJobRequest, CreateDownloadJobResponse, DownloadListResponse, DownloadUrlResponse } from '../types/download';

class DownloadAPIService {
  async createJob(request: CreateDownloadJobRequest): Promise<CreateDownloadJobResponse> {
    const response = await httpClient.post<CreateDownloadJobResponse>('downloads/create', request);
    return response.data;
  }

  async createBatchJob(batchId: string, downloadType: string = 'FI_RAW_DATA'): Promise<CreateDownloadJobResponse> {
    const response = await httpClient.post<CreateDownloadJobResponse>('downloads/batch', {
      batch_id: batchId,
      download_type: downloadType,
    });
    return response.data;
  }

  async listJobs(limit = 10, nextToken?: string): Promise<DownloadListResponse> {
    let url = `downloads/list?limit=${limit}`;
    if (nextToken) {
      url += `&next_token=${encodeURIComponent(nextToken)}`;
    }
    const response = await httpClient.get<DownloadListResponse>(url);
    return response.data;
  }

  async getDownloadUrl(jobId: string): Promise<DownloadUrlResponse> {
    const response = await httpClient.get<DownloadUrlResponse>(`downloads/${jobId}/url`);
    return response.data;
  }
}

export const downloadAPI = new DownloadAPIService();
